export const getCreditType = (type: string) => {
  switch (type) {
    case "SUBSCRIPTION":
      return "common:monthlyCredit";
    case "ONE_TIME_PURCHASE":
      return "common:purchasedCredit";
    default:
      return "-";
  }
};
